import { extractChannel } from '../tools';

/**
 * 模块表单配置上下文
 */
export default class FormContext {
  constructor(config) {
    this.config = config;
    this.setFieldStrategy();
  }

  /**
   * 实例化表单字段策略
   */
  setFieldStrategy() {
    const context = require.context('./channel-interface', false, /FieldStrategy\.js$/);
    for (const key of context.keys()) {
      if (this.config.init_ops.channel_interface === extractChannel(key, 'FieldStrategy')) {
        const FieldStrategy = context(key).default;
        this.strategy = new FieldStrategy();
        break;
      }
    }
    if (!this.strategy) {
      throw new Error('Unsupported channel type.');
    }
  }

  /**
   * 获取模块表单字段
   * @returns {Object}
   */
  async getFormFields() {
    const { dataController: controller } = this.config;
    const raw_fields = this.strategy.getFields();
    const fields = await this.strategy.setFieldsSort(raw_fields);
    this.addEvent(fields, controller);
    this.strategy.addFieldsRestriction(fields, this.config);
    await this.setFieldDataSources(fields, controller);
    return fields;
  }

  /**
   * 添加事件监听
   * @param {Object} fields
   * @param {Object} controller 控制器
   */
  addEvent(fields, controller) {
    this.strategy.addEvent(fields, controller);
  }

  /**
   * 设置表单字段数据源
   * @param {Object} fields 模块表单配置
   * @param {Object} controller 控制器
   */
  async setFieldDataSources(fields, controller) {
    await this.strategy.setFieldDataSources(fields, controller);
  }

  /**
   * 获取覆盖字段
   * @returns {Object}
   */
  getOverrides() {
    return this.strategy.getOverrides();
  }

  /**
   * 设置动态渲染组件
   * @param {Object} fields 模块表单配置
   * @param {Object} controller 控制器
   * @param {Object} payload 传递的数据，不限制键名和值
   */
  async setDynamicComponent(fields, controller, payload) {
    await this.strategy.setDynamicComponent(fields, controller, payload);
  }
}
